type PanBounds = {
  contentWidth: number;
  contentHeight: number;
  frameWidth: number;
  frameHeight: number;
  scale: number;
};

/**
 * Clamps a pan offset so a scaled element can never be dragged past the frame
 * edges (its edge stays flush with the frame at most). transform-origin is
 * centered, so the max travel on each axis is half the overflow beyond the
 * frame, and 0 once the scaled content fits inside it.
 */
export const clampPanOffset = (
  x: number,
  y: number,
  { contentWidth, contentHeight, frameWidth, frameHeight, scale }: PanBounds
): { x: number; y: number } => {
  const maxX = Math.max(0, (contentWidth * scale - frameWidth) / 2);
  const maxY = Math.max(0, (contentHeight * scale - frameHeight) / 2);

  return {
    x: Math.min(maxX, Math.max(-maxX, x)),
    y: Math.min(maxY, Math.max(-maxY, y)),
  };
};
